import styled from '@emotion/styled'

import { DataIcon, NamingConventionsIcon, UnderstandingIcon } from '@segment/matcha/components/Icons/Brandbook'
import IconWrapper from '@segment/matcha/components/IconWrapper'
import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'
import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import Divider from '@segment/matcha/components/Divider'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

const copy = {
  header: `Twilio Developer Plan`,
  description: `Get access to Data + Intelligence in Segment exclusively for Twilio developers.`,
}

const link = {
  text: `Sign up for free`,
  url: `/twilio-developer-plan/`,
}

const TwilioDeveloperPlan = () => {
  const pageConfig = usePageConfig()

  return (
    <>
      <DividerWrapper>
        <Divider />
      </DividerWrapper>
      <StyledSectionBase variant="centered">
        <Section.Copy>
          <CopyTextBase centered={true}>
            <CopyText.Heading tag="h3">{copy.header}</CopyText.Heading>
            <CopyText.Description tag="p" variant="pLarge">
              {copy.description}
            </CopyText.Description>
            <CopyText.Link href={getAbsoluteUrl(link.url, pageConfig)}>{link.text}</CopyText.Link>
          </CopyTextBase>
        </Section.Copy>
        <Section.Contents>
          <FeatureBoxGroup />
        </Section.Contents>
      </StyledSectionBase>
    </>
  )
}

const features = [
  {
    title: `Unified customer database`,
    text: `Build a unified view of your customers across web, mobile, and Twilio data in your data warehouse.`,
    icon: <NamingConventionsIcon />,
  },
  {
    title: `Query-ready data`,
    text: `Warehouse data is automatically aligned to a set schema and optimized for cost and performance.`,
    icon: <DataIcon />,
  },
  {
    title: `Deep customer insights`,
    text: `Evaluate campaign performance and deliverability metrics, analyze historical trends, and power data science models.`,
    icon: <UnderstandingIcon />,
  },
]

const FeatureBoxGroup = () => {
  return (
    <ColumnTrack columns={1} overrides={{ lg: 3 }}>
      {features.map((feature) => (
        <StyledFeatureBoxBase key={feature.title} alignment="left" headerPosition="top">
          <FeatureBox.Header>
            <IconWrapper elevation={1} variant="circle">
              {feature.icon}
            </IconWrapper>
          </FeatureBox.Header>
          <FeatureBox.Body>
            <FeatureBox.Title>{feature.title}</FeatureBox.Title>
            <FeatureBox.Text>{feature.text}</FeatureBox.Text>
          </FeatureBox.Body>
        </StyledFeatureBoxBase>
      ))}
    </ColumnTrack>
  )
}

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    row-gap: 40px;
    ${({ theme }) => theme.breakpoints.up(`xl`)} {
      padding-bottom: 120px;
    }
  }

  ${Section.Contents} {
    ${({ theme }) => theme.breakpoints.up(`xl`)} {
      padding-left: 80px;
      padding-right: 80px;
    }
  }
`

const StyledFeatureBoxBase = styled(FeatureBoxBase)`
  padding: 24px;
`

const DividerWrapper = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  padding: 24px 40px;
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    padding: 24px 80px;
  }
`

export default TwilioDeveloperPlan
